import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseConnectedDevice, ConnectedDevice } from '@app/models/connected-device.model';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class DevicesService {
    private readonly rootUrl = `${environment.urlBackend}/api/devices`;
    private readonly http = inject(HttpClient);

    public getStationsAndStorage(): Observable<ConnectedDevice[]> {
        return this.http.get<ConnectedDevice[]>(`${this.rootUrl}/stations-and-storages`);
    }

    public getAccessories(): Observable<ConnectedDevice[]> {
        return this.http.get<ConnectedDevice[]>(`${this.rootUrl}/accessories`);
    }
}
